import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import UsersModifiedByMonthByUserList from './components/month/UsersModifiedByMonthByUserList';
import UsersModifiedByWeekByUserList from './components/week/UsersModifiedByWeekByUserList';

function UsersModifiedByUser() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Users modified by user"
      MonthList={UsersModifiedByMonthByUserList}
      WeekList={UsersModifiedByWeekByUserList}
    />
  );
}

export default UsersModifiedByUser;
